export default __webpack_public_path__ + "static/media/projectThumb4.fff985ed.png";